import { useQuery } from '@apollo/client';
import { Box, DialogActions, DialogContent } from '@mui/material';
import QuestionnaireFormViewOnly from 'FeatureModules/Questionnaire/Components/QuestionnaireFormViewOnly';
import Loader from 'Components/Forms/Loader';
import QuestionnaireItem from 'FeatureModules/Questionnaire/Components/QuestionnaireResponseTable/QuestionnaireItem';
import { DialogDefault, ThemeButton } from 'DesignSystem';
import { GET_QUESTIONNAIRE } from 'graphql/secure/queries/questionnaire.queries';
import React, { FC } from 'react';
import { IDefaultDialogProps } from 'types/dialog.types';
import { IQuestionnaire } from 'FeatureModules/Questionnaire/types/questionnaire.types';
import omitDeep from 'omit-deep-lodash';
import FlexBox from 'Components/FlexBox';

interface IPreviewQuestionnaireDialogProps extends IDefaultDialogProps {
  questionnaireId: string;
}

const PreviewQuestionnaireDialog: FC<IPreviewQuestionnaireDialogProps> = ({
  open,
  questionnaireId,
  onClose,
}) => {
  const { data, loading } = useQuery<{
    questionnaire: IQuestionnaire;
  }>(GET_QUESTIONNAIRE, {
    variables: { id: questionnaireId },
  });

  //** Make sure caches risks and values on the questions are shown here */
  const questionnaire = data?.questionnaire
    ? (omitDeep(
        data?.questionnaire,
        'answerText',
        'selectedOptionIds',
        'commentText',
        'riskLevel',
        'proofDocuments'
      ) as IQuestionnaire)
    : undefined;

  return (
    <DialogDefault
      open={open}
      fullWidth
      maxWidth="md"
      title="Preview Questionnaire"
      itemTitle={questionnaire?.title}
      onClose={onClose}
    >
      <DialogContent sx={{ maxHeight: '70vh', overflowY: 'auto', background: 'white' }}>
        {loading || !questionnaire ? (
          <Box position="relative">
            <Loader />
          </Box>
        ) : (
          <FlexBox flexDirection="column" gap={2}>
            <QuestionnaireItem questionnaire={questionnaire} />
            <QuestionnaireFormViewOnly sections={questionnaire?.sections} />
          </FlexBox>
        )}
      </DialogContent>
      <DialogActions>
        <ThemeButton onClick={onClose}>Close</ThemeButton>
      </DialogActions>
    </DialogDefault>
  );
};

export default PreviewQuestionnaireDialog;
